import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";

import { useToken } from "@gluestack-style/react";
import PageLoader from "components/general/PageLoader";
import Pagination from "components/navigation/Pagination";
import { Box, HStack, Link, Text, Typography } from "components/ui";
import { BookText, Trash2 } from "lucide-react-native";
import { useIsMobile } from "utils/hooks/useIsMobile";

import PressableArea from "components/ui/PressableArea";

type Props = {
	data: any;
	deleteCatalogue: any;
	setPageNumber: React.Dispatch<React.SetStateAction<number>>;
	type: "catalogues" | "stocklists";
	isAdmin?: boolean;
};

export default function StockCollectionListingScreen({ data, deleteCatalogue, setPageNumber, type, isAdmin = false }: Props) {
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const isMobile = useIsMobile();

	if (data == null) {
		return (
			<Box borderRadius={16} minHeight={500}>
				<PageLoader />
			</Box>
		);
	}

	if (!data?.list || data.list.length === 0) {
		return (
			<Box gap={16} paddingVertical={28} paddingHorizontal={20}>
				<Typography.H3>No {type} found</Typography.H3>
				<Typography.ParagraphSmall sx={{ lineHeight: 21 }} weight="normal">
					You don't have any {type} yet. Create your first {type.slice(0, -1)} to get started.
				</Typography.ParagraphSmall>
			</Box>
		);
	}

	return (
		<Box>
			<Box>
				<GridContainer
					noPadding
					style={{
						marginLeft: 0,
						width: "100%",
						maxWidth: "100%",
					}}
				>
					{!isMobile && (
						<Row style={{ marginLeft: 0, marginRight: 0, marginBottom: 14, width: "100%", paddingHorizontal: 16 }}>
							<Col style={{ justifyContent: "center" }} xs={11} md={11}>
								<Text color="$neutral500">Catalogue</Text>
							</Col>
						</Row>
					)}

					{data?.list &&
						data?.list?.map((catalogue: any) => {
							return (
								<Link
									href={isAdmin ? `/admin/${type}/` + catalogue.id : `/${type}/` + catalogue.id}
									key={catalogue.id}
									component={(hovered: boolean) => {
										var styleData = { marginLeft: 0, marginRight: 0, paddingHorizontal: 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0" };

										if (hovered) {
											// @ts-ignore
											styleData = { ...styleData, backgroundColor: "#E1E9F0" };
										}
										return (
											<Row style={styleData} key={catalogue.id}>
												<Col style={{ justifyContent: "center" }} xs={11} md={11}>
													<HStack gap={8}>
														<BookText size={24} color={resolvedPrimarylight} />
														{/* <ListTree size={24} color={resolvedPrimarylight} /> */}
														<Text>{catalogue.name}</Text>
													</HStack>
												</Col>

												<Col style={{ justifyContent: "center" }} xs={1} md={1}>
													<PressableArea
														onPress={(ev) => {
															ev.preventDefault(); // Prevent default behavior (navigation)
															ev.stopPropagation(); // Stop event from propagating to parent
															deleteCatalogue({ id: catalogue.id });
														}}
														component={(hovered: boolean) => <Trash2 size={24} color={resolvedPrimarylight} opacity={hovered ? 1 : 0.5} />}
													></PressableArea>
												</Col>
											</Row>
										);
									}}
								></Link>
							);
						})}
				</GridContainer>
			</Box>
			<Box alignItems="center" my={24}>
				<Pagination pageCount={data.metaData?.pageCount} pageNumber={data.metaData?.pageNumber} onChangePage={setPageNumber} />
			</Box>
		</Box>
	);
}
